import {ReportType,} from '../types';
import {Stack} from '@mantine/core';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator
} from '@flexinet/ui-components';

export const Profile = ({record}: { record: ReportType }) => {

    const properties = [
        {
            label: 'Report Type ID',
            value: record.id as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        },
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        },
        {
            label: 'Version',
            value: record.version?.toString() as string,
            span: 12,
        },
        {
            label: 'Default Columns',
            value: record.defaultColumns?.join(', ') as string,
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Data Available Start',
            value: record.dataAvailableStart as unknown as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Data Available End',
            value: record.dataAvailableEnd as unknown as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as unknown as string,
            formatAs: 'Timestamp',
            span: 12,
        }];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
